<template>
  <div>
    <order-item
      v-for="order in orders"
      :key="order.ID"
      :order="order"
      :selected="isSelected(order)"
      @selection-changed="$emit('selection-changed', $event)"
      @order-assigned="$emit('order-assigned', $event)"
      @update-error="$emit('update-error', $event)"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import OrderItem from './OrderItem.vue'

const props = defineProps({
  orders: {
    type: Array,
    required: true
  },
  selectedOrders: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
})

defineEmits(['selection-changed', 'order-assigned'])

const isSelected = (order) => {
  return props.selectedOrders.some(o => o.ID === order.ID)
}
</script> 